export const UPDATE_CHANGES_TO_SAVE = 'UPDATE_CHANGES_TO_SAVE';
export const REMOVE_CHANGES_TO_SAVE = 'REMOVE_CHANGES_TO_SAVE';
